import React, { useState, useEffect } from 'react';
import { TextField, Button, Checkbox, Container, FormControlLabel, InputLabel, Select, MenuItem, Typography, Grid, Box, RadioGroup, Radio } from '@mui/material';
import Error from '../Error/Error';
import Success from '../Success/Success';
import { useTranslation } from 'react-i18next';
import { getUnitsOfMeasure, editUnitOfMeasure } from '../../api/axios';
import { useParams, useNavigate } from 'react-router-dom';

const EditUnitOfMeasure = () => {
    const { t } = useTranslation('global');
    const { id } = useParams();
    const navigate = useNavigate();
    const [name, setName] = useState('');

    const [errMsg, setErrMsg] = useState('');
    const [succ, setSucc] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch units of Measure
                const units = await getUnitsOfMeasure();
                const unit = units.find(e => e.id.toString() === id);
                if(unit){
                    setName(unit.name);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [id]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!name) {
            setErrMsg(t("editOrganizationUnit.requiredFields"));
            return;
        }

        const updatedUnitOfMeasure = {
            id,
            name
        };

        try {
            const response = await editUnitOfMeasure(updatedUnitOfMeasure);
            if (response.success) {
                setSucc(t("unitOfMeasure.successfullyUpdated"));
                setTimeout(() => setSucc(''), 3000);
            } else {
                setErrMsg(t("unitOfMeasure.updateFailed"));
                setTimeout(() => setErrMsg(''), 3000);
            }
        } catch (error) {
            setErrMsg(t("unitOfMeasure.updateFailed"));
            setTimeout(() => setErrMsg(''), 3000);
        }
    };

    return (
        <Container maxWidth="sm" className="container-employee" sx={{ p: 3, flexShrink: 0, mt: 4 }} >
            <Typography variant="h4" sx={{ mb:4 }}>{t("unitOfMeasure.editUnitOfMeasure")}</Typography>
            <form onSubmit={handleSubmit} style={{ display:"flex", justifyContent:"center", alignItems:"center"}}>
                <Grid container spacing={2}>
                    {/* Unit of measure ID - disabled */}
                    <Grid item xs={12} sm={12}>
                        <TextField
                            label={t("unitOfMeasure.id")}
                            fullWidth
                            value={id}
                            required
                            disabled
                        />
                    </Grid>
                    
                    {/* Unit of Measure name */}
                    <Grid item xs={12} sm={12}>
                        <TextField
                            label={t("unitOfMeasure.name")}
                            fullWidth
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </Grid>
                    
                    <Grid item xs={12} sm={6} sx={{ width:"100%", display:"flex", justifyContent:"flex-end"}}>
                        <Button fullWidth variant="contained" type="submit">{t("edit.save")}</Button>
                        
                    </Grid>
                    <Grid item xs={12} sm={6}>
                                                                  <Button
                                                                    fullWidth
                                                                    type="button"
                                                                    variant="contained"
                                                                    color="error"
                                                                    onClick={() => { navigate('/new-unit-of-measure') }}
                                                                  >
                                                                    {t("editReader.cancel")}
                                                                  </Button>
                                                                </Grid>
                </Grid>
            </form>

            {errMsg && <Error message={errMsg} onClose={() => setErrMsg('')} />}
            {succ && <Success message={succ} onClose={() => setSucc('')} />}
        </Container>
    );
};

export default EditUnitOfMeasure;
